import { render } from "./media.vue?vue&type=template&id=05f7f07a&scoped=true"
import script from "./media.vue?vue&type=script&lang=js"
export * from "./media.vue?vue&type=script&lang=js"

import "./media.vue?vue&type=style&index=0&id=05f7f07a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-05f7f07a"

export default script